import { Box, Input, Text, FormLabel, Button } from "@chakra-ui/react";

import { useFormik } from "formik";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { useToast } from "@chakra-ui/react";

const NewPasswordForm = ({ resetPassword }) => {
  const url = new URL(window.location.href);
  const token = url.searchParams.get("token");
  const history = useHistory();

  const toast = useToast();

  const [loading, setLoading] = useState(false);

  const validate = (values) => {
    let errors = {};
    if (!values.password) {
      errors.password = "Password is required";
    }
    if (!values.confirmPassword) {
      errors.confirmPassword = "Confirm Password is required";
    } else if (values.password !== values.confirmPassword) {
      errors.confirmPassword = "Passwords mismatch";
    }
    return errors;
  };

  const formik = useFormik({
    initialValues: {
      password: "",
      confirmPassword: "",
    },
    validate,
    onSubmit: (values, { resetForm }) => {
      setLoading(true);

      let data = {
        confirmPassword: values.confirmPassword,
        password: values.password,
      };

      resetPassword(data, token)
        .then((res) => {
          setLoading(false);
          toast({
            position: "bottom-right",
            description: "Password reset sucessfully.",
            status: "success",
            title: "Success",
            duration: 9000,
            isClosable: true,
          });
          resetForm({ values: "" });
          history.push("/login");
        })
        .catch((err) => {
          setLoading(false);

          if (err.response && err.response.data.status === false) {
            return toast({
              title: "Error",
              description: "Email address or password is incorrect",
              status: "error",
              duration: 9000,
              isClosable: true,
            });
          }
        });
    },
  });

  return (
    <>
      <Box as="form" px={8} onSubmit={formik.handleSubmit}>
        <Box mt={4}>
          <FormLabel htmlFor="password">Password</FormLabel>
          <Input
            id="password"
            type="password"
            name="password"
            onChange={formik.handleChange}
            value={formik.values.password}
          />

          {formik.errors.password ? (
            <Text color="red.500" fontSize="sm" mt={3}>
              {formik.errors.password}
            </Text>
          ) : null}
        </Box>

        <Box mt={4}>
          <FormLabel htmlFor="password">Confirm Password</FormLabel>
          <Input
            id="confirmPassword"
            type="password"
            name="confirmPassword"
            onChange={formik.handleChange}
            value={formik.values.confirmPassword}
          />

          {formik.errors.confirmPassword ? (
            <Text color="red.500" fontSize="sm" mt={3}>
              {formik.errors.confirmPassword}
            </Text>
          ) : null}
        </Box>

        <Button
          mt={8}
          isFullWidth
          colorScheme="light"
          bg="#00A2E8"
          isLoading={loading}
          type="submit"
        >
          Submit
        </Button>
      </Box>
    </>
  );
};

export default NewPasswordForm;
